import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JwtFrontendGateway } from '@cigna/cigna-for-brokers/shared/gateways';

@Injectable({
  providedIn: 'root',
})
export class JwtFrontendService {
  constructor(private _http: HttpClient, private _gw: JwtFrontendGateway) {}

  cacheProfile(sub: string) {
    return this._http.post<void>(this._gw.profileCacheUrl(sub), null);
  }
}
